<app-header (showSuccess)="showSuccess($event)" (saveDataonExit)="saveDataonExit('exit')"
  (localeChanged)="localeChanged($event)" [saveonExitfromChild1]="saveonExitfromChild"></app-header>

<div class="content" role="main">
  <div class="content-margin">
    <div class="col-xl-12 col-lg-11 col-md-11 col-sm-11 mx-auto">
      <h1 role="heading" class="mt-5 mx-2">{{ "wizard.submitClaim" | translate }}</h1>

      <ng-container *ngIf="isLargeScreen">
        <div id="main-content">

          <mat-horizontal-stepper linear labelPosition="end" #stepper (animationDone)="onTabClick()"
            (selectionChange)="saveOnTabClick($event)">
            <ng-template matStepperIcon="edit">
              <mat-icon>check</mat-icon>
            </ng-template>

            <mat-step [stepControl]="myInformation.myInformationForm" [editable]="editable">
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.myInformation" | translate }}
                </span>
              </ng-template>

              <app-my-information #myInformation [resultofSaveonExit]="saveonExittoChild + 'myInfo'"
                [personalInfo]="claim?.personalInformation" [referenceNumber]="claim.referenceNumber"
                [claimId]="claim?.claimId" [locale]="locale" (showSuccess)="showSuccess($event)" (next)="next()"
                (saveDataonExit1)="saveDataonExit1('exit')">
                <!-- (formStatus)="checkMyInformationComplete($event)" (showSuccess)="showSuccess($event)" (next)="next()"> -->
              </app-my-information>
            </mat-step>
            <mat-step label="step 2" [stepControl]="healthCare.continueHealthCareForm" [editable]="editable">
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.healthCare" | translate }}
                </span>
              </ng-template>
              <app-health-care #healthCare [resultofSaveonExit]="saveonExittoChild + 'healthcare'"
                [healthCareProviderInfo]="claim?.healthCareProviderInformation"
                [referenceNumber]="claim.referenceNumber" [claimId]="claim?.claimId" [locale]="locale" 
                [personalInformation]="claim?.personalInformation" (showSuccess)="showSuccess($event)"
                (previous)="previous()" (next)="next()" (saveDataonExit1)="saveDataonExit1('exit')">
                <!-- [personalInformation]="claim?.personalInformation" (formStatus)="checkHealthCareComplete($event)"
              (showSuccess)="showSuccess($event)" (next)="next()" (previous)="previous()"> -->

            </app-health-care>
          </mat-step>
          <mat-step [stepControl]="employment.employmentForm" [editable]="editable">
            <ng-template matStepLabel>

              <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                {{ "wizard.employment" | translate }}
              </span>
            </ng-template>
            <app-employment #employment [resultofSaveonExit]="saveonExittoChild + 'employment'"
              [employmentInfo]="claim?.employmentInformation" [referenceNumber]="claim.referenceNumber" [locale]="locale" 
              [claimId]="claim.claimId" (employmentSaved)="employmentSaved($event)" (showSuccess)="showSuccess($event)"
              (next)="next()" (previous)="previous()" (saveDataonExit1)="saveDataonExit1('exit')">
              <!-- (employmentSaved)="employmentSaved($event)" (formStatus)="checkEmploymentComplete($event)"> -->
            </app-employment>
          </mat-step>
          <mat-step [editable]="editable">
            <ng-template matStepLabel>

              <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                {{ "wizard.supportingDocuments" | translate }}
              </span>
            </ng-template>
            <app-supporting-documents #supportingDocuments [resultofSaveonExit]="saveonExittoChild + 'supportingdoc'"
              [claimId]="claim.claimId" [claimDocumentsList]="claim?.claimDocumentsList"
              [employmentInfo]="claim?.employmentInformation" [referenceNumber]="claim.referenceNumber" (next)="next()"
              (previous)="previous()" (showSuccess)="showSuccess($event)"></app-supporting-documents>
          </mat-step>
          <mat-step [completed]="false" [stepControl]="review" [editable]="editable">
            <ng-template matStepLabel>

              <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                {{ "wizard.review" | translate }}
              </span>
            </ng-template>
            <app-review [resultofSaveonExit]="saveonExittoChild + 'review'" [claimId]="claim?.claimId" 
              [currentPosition]="stepper" [checkChanges]="emitChanges" (next)="next()" (previous)="previous()"
              (setTabindex)="setTabindex($event)">
            </app-review>
          </mat-step>
          <mat-step [stepControl]="confirmation" [editable]="!editable">
            <ng-template matStepLabel>
              <span class="fontsizestepper confirmation">
                {{ "wizard.confirmation" | translate }}
              </span>
            </ng-template>
            <app-confirmation *ngIf="selectedIndex === 5" [currentLocale]="locale"></app-confirmation>
          </mat-step>
        </mat-horizontal-stepper>
      
     
        </div>
      </ng-container>

      <ng-container *ngIf="!isLargeScreen">
        <div id="main-content">
          <mat-vertical-stepper linear labelPosition="end" #stepper (animationDone)="onTabClick()"
            (selectionChange)="saveOnTabClick($event)">


            <mat-step [stepControl]="myInformation.myInformationForm" [editable]="editable">
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.myInformation" | translate }}
                </span>
              </ng-template>
              <app-my-information #myInformation [resultofSaveonExit]="saveonExittoChild + 'myInfo'"
                [personalInfo]="claim?.personalInformation" [referenceNumber]="claim.referenceNumber"
                [claimId]="claim?.claimId" [locale]="locale" (formStatus)="checkMyInformationComplete($event)"
                (showSuccess)="showSuccess($event)" (next)="next()" (saveDataonExit1)="saveDataonExit1('exit')">
              </app-my-information>
            </mat-step>

            <mat-step [stepControl]="healthCare.continueHealthCareForm" [editable]="editable">
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.healthCare" | translate }}
                </span>
              </ng-template>
              <app-health-care #healthCare [resultofSaveonExit]="saveonExittoChild + 'healthcare'"
                [healthCareProviderInfo]="claim?.healthCareProviderInformation"
                [referenceNumber]="claim.referenceNumber" [claimId]="claim?.claimId"  [locale]="locale"
                [personalInformation]="claim?.personalInformation" (formStatus)="checkHealthCareComplete($event)"
                (showSuccess)="showSuccess($event)" (next)="next()" (previous)="previous()"
                (saveDataonExit1)="saveDataonExit1('exit')">
              </app-health-care>
            </mat-step>


            <mat-step [stepControl]="employment.employmentForm" [editable]="editable">
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.employment" | translate }}
                </span>
              </ng-template>
              <app-employment #employment [resultofSaveonExit]="saveonExittoChild + 'employment'"
                [employmentInfo]="claim?.employmentInformation" [referenceNumber]="claim.referenceNumber"
                [claimId]="claim.claimId" (employmentSaved)="employmentSaved($event)"  [locale]="locale"
                (formStatus)="checkEmploymentComplete($event)" (next)="next()" (previous)="previous()" (saveDataonExit1)="saveDataonExit1('exit')">
              </app-employment>
              
            </mat-step>

            <mat-step [editable]="editable" >
              <ng-template matStepLabel>
                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.supportingDocuments" | translate }}
                </span>
              </ng-template>
              <app-supporting-documents [resultofSaveonExit]="saveonExittoChild + 'supportingdoc'"
                [claimId]="claim.claimId" [claimDocumentsList]="claim?.claimDocumentsList"
                [employmentInfo]="claim?.employmentInformation" [referenceNumber]="claim.referenceNumber"
                (next)="next()" (previous)="previous()" (showSuccess)="showSuccess($event)"></app-supporting-documents>
            </mat-step>

            <mat-step [stepControl]="review" [editable]="editable"
              >
              <ng-template matStepLabel>

                <span class="fontsizestepper" [ngClass]="{'allow': selectedIndex != 5}">
                  {{ "wizard.review" | translate }}
                </span>
              </ng-template>
              <app-review [resultofSaveonExit]="saveonExittoChild + 'review'" [claimId]="claim?.claimId"
                [currentPosition]="stepper" [checkChanges]="emitChanges" (next)="next()" (previous)="previous()"
                (setTabindex)="setTabindex($event)">
              </app-review>
            </mat-step>

            <mat-step [stepControl]="confirmation" [editable]="!editable"
             >
              <ng-template matStepLabel>
                <span class="fontsizestepper">
                  {{ "wizard.confirmation" | translate }}
                </span>
              </ng-template>
              <app-confirmation *ngIf="selectedIndex === 5" [currentLocale]="locale" ></app-confirmation>
            </mat-step>
          </mat-vertical-stepper>
        </div>
      </ng-container>
    </div>
  </div>
</div>